import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { CookieService } from 'ngx-cookie-service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var $ : any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  username : string = "";
  isLoginError : boolean = false;
  isPasswordChangeError = false;
  loginErrorText : string = "";

  constructor(private authService : AuthService, 
    private cookies : CookieService, 
    private router : Router,
    private spinnerService: Ng4LoadingSpinnerService) {  }

  ngOnInit() {
    this.username = "";
    this.isPasswordChangeError = false;
    this.loginErrorText = "Your user name and/or password is incorrect. Click 'Forgot your password?' above if you need help.";
    this.spinnerService.hide();
  }

  OnSubmit(username,password){
    this.username = username;
    $("#btnLogin").attr('disabled','disabled');
    this.spinnerService.show();
    this.authService.authenticate(username,password)
      .subscribe(
        (data : any)=>{
          let accountUser = {
            'userName': data.userName,
            'fullName': data.fullName,
            'accountName':data.accountName,
            'isLabAdmin': data.isLabAdmin,
            'reportDelivery': data.reportDelivery
          };

          localStorage.setItem('accountUser', JSON.stringify(accountUser));
          let isLoggedIn = this.authService.isLoggedIn.subscribe(); //Need this to force AuthService to refresh its isLoggedIn state.
          this.spinnerService.hide();
          this.router.navigate(['/reporting/testreportlist']);
        },
        (err : HttpErrorResponse)=>{
          this.spinnerService.hide();
          $("#btnLogin").attr('disabled',false);
          let errorCode = 0;
          this.isLoginError = true;
          console.log(err);
          try {errorCode = err.error.ldapErrorCode} catch(e){}
          if (errorCode != 0)
          {
            console.log(err.error.ldapErrorCode);
            switch(err.error.ldapErrorCode)
            {
              case "773":
              case "532":
                $("#btnForceResetNow").click();
                break;
              case "533":
              case "701":
              case "775":
                  this.loginErrorText = err.error.ldapErrorText;
                  break;
              default:
                this.loginErrorText = "Your user name and/or password is incorrect. Click 'Forgot your password?' above if you need help.";
                break;
            }
          }
        }
      );
  }

  showPasswordResetModal(){
    let modal = $(`#forceResetModal`);
    modal.addClass('show');
    modal.css({'display':'block'});
  
    $('.modal-dialog').draggable({
      handle: ".modalHeader"
    });

    this.centerModal();
  }
  
  onResize(event) {
    this.centerModal();
  }

  centerModal()
  {
    $('.modal-dialog')[0].style.top = "0px";
    if (window.innerWidth < 500)
    {
      $('.modal-dialog')[0].style.left = 0;
    }
    else
    {
      $('.modal-dialog')[0].style.left = ((window.innerWidth - 375) / 2) + "px";
    }
  }

  ChangePassword(password, newPassword)
  {
    this.isPasswordChangeError = false;
    this.authService.setPassword(this.username, password, newPassword)
        .subscribe(
          (data:any) => {
            $('#btnResetPw').removeClass('btn-info');
            $('#btnResetPw').removeClass('btn-danger');
            $('#btnResetPw').addClass('btn-success');
            setTimeout(
              ()=>{this.doLogin(newPassword);}, 2000);
          },
          (err: HttpErrorResponse) => {
            console.log(err);
            $('#btnResetPw').removeClass('btn-info');
            $('#btnResetPw').addClass('btn-danger');
            this.isPasswordChangeError = true;
          }
        );
  }

  doLogin(password){
    let modal = $(`#forceResetModal`);
    // modal.removeClass('show');
    // modal.css({'display':'none'});
    $(".modal-backdrop").remove();
    this.OnSubmit(this.username, password);
  }
}
